import React from 'react';
import { LoadingSpinner } from 'yankees-react-utils';
import { useTranslation } from 'react-i18next';
import PitchTabTable from './PitchTabTable';

const OverallTab = ({ isLoading, pitchTypes, isLhp, isLoadingAvg }) => {
    const { t: translate } = useTranslation();

    if (isLoading) {
        return (
            <div className="py-5 text-center">
                <LoadingSpinner />
            </div>
        );
    }

    const filteredPitchTypes = pitchTypes.filter((pt) => pt.balls === -1 && pt.strikes === -1);

    return (
        <div>
            {filteredPitchTypes.length
                ? (
                    <>
                        <h4>{translate('sections.reports.pitcher.overall')}</h4>
                        <PitchTabTable pitchTypes={filteredPitchTypes} isLhp={isLhp} isLoadingAvg={isLoadingAvg} />
                    </>
                )
                : <div className="py-5 text-center fs-6">{translate('pitcher-overview.no-data')}</div>}
        </div>
    );
};

export default OverallTab;
